var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPermanentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ic.Single Premium Whole Life.24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.024
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12090",
    d: "M0 0h24v24.024H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12091",
    d: "M5.984 21.021H4a1 1 0 01-1-1v-6.008a1 1 0 011-1h1.984a1 1 0 011 1v6.006a1 1 0 01-1 1.002z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12092",
    d: "M12.96 17.015h2.324a1.983 1.983 0 001.195-.4l2.406-1.814a1.5 1.5 0 011.972.141h0a1.522 1.522 0 010 2.144l-2.064 2.075a3.979 3.979 0 01-2.036 1.1l-2.919.587a3.964 3.964 0 01-1.748-.042l-2.639-.663a3.923 3.923 0 00-.966-.12h-1.5",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12093",
    d: "M12.96 17.013h1.479a1.513 1.513 0 001.509-1.517v-.3a1.514 1.514 0 00-1.143-1.47l-2.283-.574a4.66 4.66 0 00-1.134-.139h0a4.654 4.654 0 00-2.594.79l-1.81 1.21",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12094",
    d: "M15.286 3.665l-.349.373-.35-.373a2.085 2.085 0 00-2.887-.153h0a2.134 2.134 0 00-.257 2.946 20.529 20.529 0 003.494 3.553 20.713 20.713 0 003.57-3.649 2.051 2.051 0 00-.287-2.81l-.038-.033a2.088 2.088 0 00-2.9.146z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}

export default SvgPermanentIcon;


//////////////////
// WEBPACK FOOTER
// ./src/icons/PermanentIcon.svg
// module id = 885
// module chunks = 101